export const UnpublishedMarker = ({ iconTint }: { iconTint: string }) => {
    return (
        <div
            style={{
                width: '12px',
                height: '12px',
                backgroundColor: iconTint || 'var(--rwl-icon-default)',
                borderRadius: '50%',
            }}
        />
    );
};
